<div class="offcanvas-header">
  <h5 class="mb-0 offcanvas-title" id="offcanvasRightLabel">
    {{ frmText }}
  </h5>
  <button
    type="button"
    class="btn-close"
    data-bs-dismiss="offcanvas"
    aria-label="Close"
    #closeBtn
  ></button>
</div>

<div class="offcanvas-body p-3 d-flex flex-column mb-3 position-relative">
  <div class="shipping-carrier-loading-overlay" *ngIf="isShippingCarrierLoading">
    <div class="text-center">
      <div class="spinner-border text-primary mb-2" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="loading-text">Fetching shipping carriers...</div>
    </div>
  </div>

  <fieldset class="p-0 m-0 border-0 h-100 d-flex flex-column" [disabled]="isShippingCarrierLoading">
    <div class="container-fluid">
      <div class="mb-4">
        <label class="form-label required">Carrier</label>
        <ng-select
          [disabled]="carrierMapping.id > 0"
          [items]="carriers"
          bindLabel="name"
          bindValue="id"
          [(ngModel)]="carrierMapping.carrierId"
          placeholder="Search/select carrier..."
          [searchable]="true"
          [clearable]="false"
          notFoundText="No carriers found"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            {{ item.name || 'Search/select carrier...' }}
          </ng-template>
        </ng-select>
      </div>

      <div class="mb-4">
        <label class="form-label required">Marketplace</label>
        <select
          [disabled]="carrierMapping.id > 0"
          class="form-select"
          [(ngModel)]="carrierMapping.marketplace"
          (ngModelChange)="onMarketplaceChange($event)"
        >
          <option *ngFor="let option of marketplaceOptions" [ngValue]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="mb-4">
        <label class="form-label required">Shipping Name</label>
        <ng-select
          [items]="filteredShippingCarriers"
          bindLabel="description"
          bindValue="description"
          [(ngModel)]="carrierMapping.shippingName"
          placeholder="Search/select shipping name..."
          [searchable]="true"
          [clearable]="false"
          [loading]="isShippingCarrierLoading"
          [searchFn]="searchShippingCarrier"
          [disabled]="carrierMapping.marketplace !== Marketplace.eBay"
          notFoundText="No shipping names found"
          (ngModelChange)="onShippingNameChange($event)"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            {{ item.description || 'Search/select shipping name...' }}
          </ng-template>
        </ng-select>
        <small
          class="text-muted d-block pt-1 ps-1"
          *ngIf="carrierMapping.marketplace !== Marketplace.eBay"
        >
          Shipping names are currently available only for eBay.
        </small>
      </div>

      <div class="mb-4">
        <label class="form-label required">Shipping Code</label>
        <input
          type="text"
          class="form-control"
          placeholder="Auto populated from shipping name"
          [(ngModel)]="carrierMapping.shippingCode"
          [disabled]="true"
        />
      </div>
    </div>

    <div class="offcanvas-footer d-flex justify-content-end align-items-center pt-4">
      <button class="btn cancel-btn me-3" data-bs-dismiss="offcanvas" [disabled]="isLoading">
        Cancel
      </button>
      <button
        class="btn primary-btn"
        [disabled]="isSaveDisabled() || isLoading"
        (click)="manageCarrierMarketplaceMappingOperation()"
        (mousedown)="showRequiredFieldsMessage($event)"
      >
        <span *ngIf="!isLoading">Save Mapping</span>
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"></span>
      </button>
    </div>
  </fieldset>
</div>
